<template>
  <v-card variant="outlined" class="mt-2">
    <v-card-text>
      <v-data-table
          :headers="headers"
          :items="normalizedItems"
          :items-per-page="itemsPerPage"
          class="elevation-0"
          fixed-header
          height="360"
      >
        <template #item.type="{ item }">
          <v-chip size="small" :color="badgeColor(item.type)" variant="flat" class="cm-type-chip">
            {{ typeLabel(item.type) }}
          </v-chip>
        </template>

        <template #item.name="{ item }">
          <v-tooltip location="top" :v-if="item.score !== null && item.score !== '' && item.score !== undefined">
            <template #activator="{ props }">
      <span v-bind="props" style="cursor: help;">
        <a
            v-if="item.ep"
            :href="item.ep"
            target="_blank"
            rel="noopener"
            class="text-decoration-none"
        >
          {{ item.name }}
        </a>
        <span v-else>{{ item.name }}</span>
      </span>
            </template>
            Related score: {{ formatScore(item.score) }}
          </v-tooltip>
        </template>


        <template #item.actions="{ item }">
          <v-btn
              size="small"
              variant="outlined"
              :href="searchHref(item.name)"
              title="Entity Search"
          >
            <i class="fas fa-search"></i>
            Entity Search
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CmERelatedTable",
  props: {
    items: {type: Array, default: () => []},
    searchUrl: {type: String, default: "/jl/cm-e-search/"}, // wird überschrieben
    itemsPerPage: {type: Number, default: 10},
  },
  computed: {
    headers() {
      return [
        {title: "Type", key: "type", sortable: true, width: "140px"},
        {title: "Name (Link to Dataset)", key: "name", sortable: true},
        {title: "Entity Search", key: "actions", sortable: false, width: "190px"},
      ];
    },
    normalizedItems() {
      return (this.items || []).map((it) => ({
        ep: it.ep || "",
        name: it.name || "",
        // Default: unknown/other
        type: (it.type || "UNK").toUpperCase(),
        score: it.score ?? null,
      }));
    },
  },
  methods: {
    searchHref(name) {
      const q = encodeURIComponent(name || "");
      // searchUrl kommt aus data-search-url -> "/jl/cm-e-search/"
      return `${this.searchUrl}?q=${q}`;
    },
    formatScore(v) {
      const n = Number(v);
      if (Number.isFinite(n)) {
        // kurz + stabil
        return n.toPrecision(4);
      }
      return String(v);
    },
    badgeColor(type) {
      if (type === "PER") return "primary";
      if (type === "LOC") return "info";
      if (type === "ORG") return "success";
      return "dark"; // UNK/other
    },
    typeLabel(type) {
      if (type === "PER") return "person";
      if (type === "LOC") return "location";
      if (type === "ORG") return "organization";
      return "unknown";
    },
  },
};
</script>

<style scoped>
/* sorgt dafür, dass die Type-Spalte nicht “wackelt” */
.cm-type-chip {
  min-width: 92px;
  justify-content: center;
}
</style>
